module.exports = __webpack_public_path__ + "static/media/mode-2041.6e0ab377.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2041.svg
// module id = 1052
// module chunks = 2